<div class="sm:inset-0 flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent">

  <!-- Header -->
  <div class="p-6 sm:p-10 border-b bg-card dark:bg-transparent" style="background-color: #f1f5f9;">

    <div class="flex items-start md:items-center flex-col md:flex-row relative gap-6">
      <!-- Title-->
      <div class="ml-2 lg:ml-0 text-3xl sm:text-4xl tracking-tight leading-none">Marine Part Register</div>

      <!-- Main actions -->
      <div class="flex flex-auto items-center gap-4 md:absolute md:right-[2.5rem] w-full md:w-max">

        <!-- Filters -->
        <mat-form-field
            class="hidden xl:flex flex-auto fuse-mat-rounded fuse-mat-dense min-w-50"
            [subscriptSizing]="'dynamic'">
            <mat-select matInput [value]="selectedCategory" placeholder="Filter Category" (selectionChange)="selectedCategoryChanged($event)">
                <mat-option [value]="null">All</mat-option>
                <ng-container *ngFor="let cat of categories">
                    <mat-option [value]="cat">{{cat}}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
        <mat-form-field
            class="hidden xl:flex flex-auto fuse-mat-rounded fuse-mat-dense min-w-50"
            [subscriptSizing]="'dynamic'">
            <mat-select matInput [value]="selectedSupplier" placeholder="Filter Supplier" (selectionChange)="selectedSupplierChanged($event)">
                <mat-option [value]="null">All</mat-option>
                <ng-container *ngFor="let supplier of suppliers">
                    <mat-option [value]="supplier">{{supplier}}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <!-- Search -->
        <div class="flex-auto">
            <mat-form-field
                class="fuse-mat-dense fuse-mat-rounded w-full min-w-64"
                subscriptSizing="dynamic">
                <mat-icon
                    class="icon-size-5"
                    matPrefix
                    [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                    <input
                    matInput
                    (change)="search($event)"
                    [autocomplete]="'off'"
                    [placeholder]="'Search Marine Parts'">
            </mat-form-field>
        </div>
        <!-- Toggle Archive -->
        <mat-slide-toggle
            [checked]="showArchived"
            (change)="toggleArchive($event)"
            [color]="'primary'">
            <span class="ml-2">Archived</span>
        </mat-slide-toggle>
        <!-- Add part button -->
        <button
            mat-flat-button
            [color]="'primary'"
            (click)="openMarinePartDetails()">
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            <span class="ml-2 mr-1">Add</span>
        </button>
      </div>
    </div>

    <!-- Secondary actions -->
    <div class="xl:hidden flex-col md:flex-row gap-6 flex flex-auto justify-end md:items-center gap-4 mt-6 -mb-4 w-full">
        <!-- Filters -->
        <mat-form-field
            class="w-full fuse-mat-dense max-w-80"
            [subscriptSizing]="'dynamic'">
            <mat-select matInput [value]="selectedCategory" placeholder="Filter Category" (selectionChange)="selectedCategoryChanged($event)">
                <mat-option [value]="null">All</mat-option>
                <ng-container *ngFor="let cat of categories">
                    <mat-option [value]="cat">{{cat}}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <mat-form-field
            class="w-full fuse-mat-dense max-w-80"
            [subscriptSizing]="'dynamic'">
            <mat-select matInput [value]="selectedSupplier" placeholder="Filter Supplier" (selectionChange)="selectedSupplierChanged($event)">
                <mat-option [value]="null">All</mat-option>
                <ng-container *ngFor="let supplier of suppliers">
                    <mat-option [value]="supplier">{{supplier}}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
    
  </div>

  <!-- Main -->
  <div class="flex flex-auto">

    <!-- Marine Part list -->
    <div class="scrollable-list flex flex-col flex-auto">
      <ng-container *ngIf="marineParts">
        <ng-container *ngIf="marineParts.length > 0; else noMarineParts">
          <div class="grid">

            <!-- Header -->
            <div
                class="z-10 sticky top-0 grid grid-cols-10 gap-4 py-4 px-6 md:px-8 shadow text-md items-center text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                <div class="col-span-3">Description</div>
                <div class="col-span-2">Supplier</div>
                <div class="col-span-2">Category</div>
                <div>Cost</div>
                <div>Price</div>
                <div class="text-right">Actions</div>
            </div>

            <!-- Rows -->
            <ng-container *ngFor="let row of marineParts">
              <div class="project-row grid grid-cols-10 gap-4 items-center py-3 px-6 md:px-8 border-b">

                <!-- Columns -->
                <div class="col-span-3 line-clamp-2" [matTooltip]="row.partName">
                  <span *ngIf="!isAdmin">{{ row.partName }}</span>
                  <div *ngIf="isAdmin" class="editable-cell">
                    <input
                      [spellcheck]="'false'"
                      [value]="row.partName"
                      [placeholder]="'Part Name'"
                      (focusout)="UpdateItem($event, 'partName', row)"
                      (keydown.enter)="itemMarinePartNameInput.blur()"
                      #itemMarinePartNameInput>
                  </div>
                </div>

                <div class="col-span-2 line-clamp-2" [matTooltip]="row.supplier">
                  <span *ngIf="!isAdmin">{{ row.supplier }}</span>
                  <div *ngIf="isAdmin" class="editable-cell">
                    <input
                      [spellcheck]="'false'"
                      [value]="row.supplier"
                      [placeholder]="'Supplier'"
                      (focusout)="UpdateItem($event, 'supplier', row)"
                      (keydown.enter)="itemMarineSupplierInput.blur()"
                      #itemMarineSupplierInput>
                  </div>
                </div>

                <div class="col-span-2 line-clamp-2" [matTooltip]="row.category">
                  <span *ngIf="!isAdmin">{{ row.category }}</span>
                  <div *ngIf="isAdmin" class="editable-cell">
                    <input
                      [spellcheck]="'false'"
                      [value]="row.category"
                      [placeholder]="'Category'"
                      (focusout)="UpdateItem($event, 'category', row)"
                      (keydown.enter)="itemMarineCategoryInput.blur()"
                      #itemMarineCategoryInput>
                  </div>
                </div>

                <div class="line-clamp-2" [matTooltip]="row.cost">
                  <span *ngIf="!isAdmin">{{ row.cost | currency:'GBP' }}</span>
                  <div *ngIf="isAdmin" class="editable-cell">
                    <span matPrefix>£</span>
                    <input
                      [spellcheck]="'false'"
                      [value]="row.cost.toFixed(2)"
                      type="number"
                      step="0.01"
                      [placeholder]="'Cost'"
                      (focusout)="UpdateItem($event, 'cost', row)"
                      (keydown.enter)="itemMarineCostInput.blur()"
                      #itemMarineCostInput>
                  </div>
                </div>

                <div class="line-clamp-2" [matTooltip]="row.price">
                  <span *ngIf="!isAdmin">{{ row.price | currency:'GBP' }}</span>
                  <div *ngIf="isAdmin" class="editable-cell">
                    <span matPrefix>£</span>
                    <input
                      [spellcheck]="'false'"
                      [value]="row.price.toFixed(2)"
                      type="number"
                      step="0.01"
                      [placeholder]="'Price'"
                      (focusout)="UpdateItem($event, 'price', row)"
                      (keydown.enter)="itemMarinePriceInput.blur()"
                      #itemMarinePriceInput>
                  </div>
                </div>

                <!-- Actions -->
                <div class="flex justify-end gap-1">
                  <button [disabled]="showArchived" mat-icon-button class="w-7 h-7 min-h-7" [matTooltip]="'Edit'" (click)="openMarinePartDetails(row)">
                      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                  </button>
                  <button mat-icon-button class="w-7 h-7 min-h-7" [matTooltip]="showArchived ? 'Restore' : 'Archive'" (click)="archiveMarinePart(row, !showArchived)">
                      <mat-icon class="icon-size-5" [svgIcon]="showArchived ? 'mat_outline:restore' : 'heroicons_outline:trash'"></mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>

          </div>

          <!-- Paginator -->
          <mat-paginator
              class="mt-auto sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 bg-white"
              [ngClass]="{'pointer-events-none': isLoading}"
              [length]="page?.totalElements"
              [pageIndex]="page?.pageIndex"
              [pageSize]="page?.pageSize"
              [pageSizeOptions]="[5, 10, 25, 100]"
              [showFirstLastButtons]="true"
              (page)="setPageInfo($event)"></mat-paginator>

        </ng-container>
      </ng-container>

      <ng-template #noMarineParts>
        <div class="p-8 sm:p-16 border-t text-4xl  tracking-tight text-center">
          {{ !searchTerm ? "No marine parts available!" : "No marine parts found!" }}
        </div>
      </ng-template>

    </div>
  </div>

</div>
